'use client';

import { useContext } from 'react';
import { Box, Button, Container, Heading, Text } from '@doist/marketist';
import GetStartedButton from 'components/Get-Started-Button/Get-Started-Button';
import { ReviewsCounter } from 'components/reviews-counter/reviews-counter';
import { useTranslation } from 'next-i18next';
import { useCTAsData } from 'services/hooks/use-ctas-data';
import css from './intro.module.css';
import { UserContextV2 } from '@/app/services/providers/contexts/user-context';
export function Intro() {
  const {
    t
  } = useTranslation('pricing_v2_3');
  const {
    t: tCommon
  } = useTranslation('common');
  const {
    user
  } = useContext(UserContextV2);
  const ctaData = useCTAsData('pricing-page-intro');
  return <Container width="sm" className={css.intro} data-sentry-element="Container" data-sentry-component="Intro" data-sentry-source-file="intro.tsx">
            <Heading level="1" size="major-2xl" data-sentry-element="Heading" data-sentry-source-file="intro.tsx">
                {t('hero.title')}
            </Heading>
            <Text size="body-lg" className="mbs-24 mbe-32" data-sentry-element="Text" data-sentry-source-file="intro.tsx">
                {t('hero.subtitle')}
            </Text>
            <Box className="mbe-16" data-sentry-element="Box" data-sentry-source-file="intro.tsx">
                {!user && <GetStartedButton size="xl" />}
                {ctaData && <Button size="large" variant={ctaData.variant} href={ctaData.href} {...ctaData.dataAttributes}>
                        {ctaData.text}
                    </Button>}
            </Box>
            <ReviewsCounter t={tCommon} data-sentry-element="ReviewsCounter" data-sentry-source-file="intro.tsx" />
        </Container>;
}